export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover a regra da agenda <strong>${this.currentEntity.agenda.name}</strong><br>com validade entre <strong>${this.currentEntity.valid_to_start}</strong> e <strong>${this.currentEntity.valid_to_end}?</strong>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/index/resources/computed.js